// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import OurExpertisePage from "../pages/OurExpertise/OurExpertise";
const __wvcRoutePaths = ["/OurExpertisePage", "/our-expertise"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["connect", "connectpage", "home", "homepage", "insights", "insightspage", "our-expertise", "ourexpertisepage", "post", "the-itls-approach", "theitlsapproachpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      <Route path={__wvcRoutePaths[0]} element={<OurExpertisePage />} />
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<OurExpertisePage />} />
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
